import * as React from "react";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import {
  clearProviderSearchData,
  clearSelectedProvidersData,
} from "utils/Helpers";

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const SessionResetContainer: React.FC<{}> = () => {
  const query = useQuery();
  const sessionId = query.get("sessionId");
  clearProviderSearchData();
  clearSelectedProvidersData();
  const redirectTo = `/session/${sessionId}${window.location.search}`;
  return <Redirect to={redirectTo} />;
};

export default SessionResetContainer;
